import axios from 'axios'
import urlGenerator from './url-generator'
import { property } from 'lodash'
import createRequestConfig from './create-request-config'

const fetch = () => axios.get(urlGenerator.systemSettings(), createRequestConfig()).then(property('data'))
const update = ({ id, value }) => axios.put(urlGenerator.systemSetting(id), { value }, createRequestConfig()).then(property('data'))

export default {
    fetch,
    update,
}